import React, { useEffect, useState,memo } from "react";
import Top5Charts from "./Top5Charts";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";

const Top5KPI = memo(({ data }) => {
  const [rows, setRows] = useState([]);

  const [columns, setColumns] = useState([
    {
      field: "id",
      headerName: "Ranking",
      width: 80,
      hide: true,
      headerAlign: "center",
      renderCell: (params) => {
        if (params.row.id === 1)
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#FFD700"
            >
              <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Zm-20 200h80v-400H380v80h80v320Z" />
            </svg>
          );
        else if (params.row.id === 2)
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#C0C0C0"
            >
              <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320ZM360-280h240v-80H440v-80h80q33 0 56.5-23.5T600-520v-80q0-33-23.5-56.5T520-680H360v80h160v80h-80q-33 0-56.5 23.5T360-440v160Z" />
            </svg>
          );
        else if (params.row.id === 3)
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#CD7F32"
            >
              <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320ZM360-280h160q33 0 56.5-23.5T600-360v-60q0-26-17-43t-43-17q26 0 43-17t17-43v-60q0-33-23.5-56.5T520-680H360v80h160v80h-80v80h80v80H360v80Z" />
            </svg>
          );
        else if (params.row.id === 4)
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Zm40 200h80v-400h-80v160h-80v-160h-80v240h160v160Z" />
            </svg>
          );
        else if (params.row.id === 5)
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320ZM360-280h160q33 0 56.5-23.5T600-360v-80q0-33-23.5-56.5T520-520h-80v-80h160v-80H360v240h160v80H360v80Z" />
            </svg>
          );
      },
    },
    {
      field: "Room",
      headerName: "Room",
      width: 120,
      editable: false,
      headerAlign: "center",
    },
    {
      field: "noOfPeople",
      headerName: "Number of People",
      width: 120,
      editable: false,
      renderCell: (params) => {
        return (
          <Top5Charts
            avgUtil={params.row.noOfPeople}
            noOfChair={params.row.noOfChair}
            conditions={{
              Good: {
                Min: 1,
                Max: 2,
              },
              Moderate: {
                Min: 3,
                Max: 4,
              },
              Poor: {
                Min: 0,
                Max: 5,
              },
            }}
            type={1}
          />
        );
      },
    },
    {
      field: "noOfEmptySeat",
      headerName: "Number of Seat",
      width: 120,
      editable: false,
      renderCell: (params) => {
        return (
          <Top5Charts
            avgUtil={params.row.noOfEmptySeat}
            noOfChair={params.row.noOfChair}
            conditions={{
              Good: {
                Min: 0,
                Max: 30,
              },
              Moderate: {
                Min: 30,
                Max: 50,
              },
              Poor: {
                Min: 50,
                Max: 100,
              },
            }}
            type={2}
          />
        );
      },
    },
    {
      field: "utilizationRate",
      headerName: "Occupancy Utilization Rate",
      width: 120,
      editable: false,
      renderCell: (params) => {
        return (
          <Top5Charts
            avgUtil={params.row.utilizationRate}
            noOfChair={params.row.noOfChair}
            conditions={{
              Good: {
                Min: 50,
                Max: 100,
              },
              Moderate: {
                Min: 30,
                Max: 50,
              },
              Poor: {
                Min: 0,
                Max: 30,
              },
            }}
            type={3}
          />
        );
      },
    },
    {
      field: "spaceUtilizationRate",
      headerName: "Space Utilization Rate",
      width: 120,
      editable: false,
      renderCell: (params) => {
        return (
          <Top5Charts
            avgUtil={params.row.spaceUtilizationRate}
            noOfChair={params.row.noOfChair}
            conditions={{
              Good: {
                Min: 50,
                Max: 100,
              },
              Moderate: {
                Min: 30,
                Max: 50,
              },
              Poor: {
                Min: 0,
                Max: 30,
              },
            }}
            type={4}
          />
        );
      },
    },
    {
      field: "quickAnalysis",
      headerName: "Quick Insight",
      width: 150,
      editable: false,
      headerAlign: "center",
    },
  ]);

   


  useEffect(() => {
    let initialRows = [];
    if (data) {
      initialRows = data?.map((row, index) => ({
        id: index + 1,
        ...row,
        quickAnalysis:
          "This occupancy utilization graph indicates a period of steady low usage initially, followed by a significant increase in occupancy with brief intervals of fluctuating peaks before gradually stabilizing back to lower utilization. The pattern suggests possible scheduled high-demand activities followed by periodic changes in usage intensity.",
      }));
      setRows(initialRows);
    }
  }, [data]);

  return (
    <>
      {rows.length && columns.length ? (
        <>
          <Box sx={{ height: "100%", width: "100%", overflow: "auto" }}>
            <DataGrid
              sx={{
                height: "320px",
                color: "white",
                "& .MuiDataGrid-menuIconButton": {
                  color: "white",
                },
                "& .MuiCheckbox-root": {
                  color: "white",
                },

                "& .MuiDataGrid-sortIcon": {
                  color: "white",
                },

                "& .MuiTablePagination-root": {
                  bgcolor: "white",
                },
                "& .MuiDataGrid-cell": {
                  border: 0,
                },
                "& .MuiDataGrid-row:hover": {
                  bgcolor: "primary.main",
                },
                "& .MuiDataGrid-cell:hover": {
                  bgcolor: "none",
                },
                "& .MuiDataGrid-cell:focus": {
                  bgcolor: "primary.light",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                  lineHeight: "1.5",
                  whiteSpace: "normal",
                  textAlign: "center",
                },

                "& .MuiDataGrid-cell": {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center", // Centering cell content
                },
                '& .MuiDataGrid-footerContainer': {
                  display: 'none', // Or use height: 0 and min-height: 0
                },
                '& .MuiDataGrid-root': {
                  overflow: 'hidden', // Clip the background
                },
              }}
              rows={rows}
              columns={columns}
              initialState={{}}
              checkboxSelection
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              pagination={false} // Disables pagination
              
            />
          </Box>
        </>
      ) : null}
    </>
  );
});

export default Top5KPI;
